import axios from 'axios';
import Urls from '../consts/Urls';

const adminApi = axios.create({
    baseURL: Urls.adminHttpUrl,
});

adminApi.interceptors.request.use((config) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
});

export default adminApi;
